// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentDIV {
    position: relative;
    overflow: auto;
    height: 500%;
    width: 500%;
    background: var(--workflow-background);
    font-family: var(--workflow-font-family);
}

.leftColumn {
    border-right: 1px solid black;
    width: 275px;
    position: relative;
    font-family: var(--workflow-font-family);
}
.leftColumnHidden{
    width:0px;
}

.moduleItem {
    position: absolute;
}

.dropDIV {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px;
    z-index: 1;
}

.treeDiv {
    overflow: hidden;
}

.SettingsPanel {
    width: auto;
    background: var(--appbuilder-background);
    height: auto;
    padding: 10px;
    /*border: var(--appbuilder-border-thickness) solid var(--appbuilder-border-color);
    border-top-left-radius: var(--appbuilder-border-radius-top-left);
    border-top-right-radius: var(--appbuilder--border-radius-top-right);
    border-bottom-left-radius: var(--appbuilder--border-radius-bottom-left);
    border-bottom-right-radius: var(--appbuilder--border-radius-bottom-right);*/
    position: absolute;
    z-index: 10;
    grid-template-rows: 1fr auto;
    display: grid;
    max-width:1000px;
}
.SettingsPanelContent{
    grid-row-start:1;
    grid-row-end:1;
    overflow:auto;
    max-width:980px;
}

.fullscreen .SettingsPanelContent {
    max-width: 100vw;
}
.SettingsPanelActions {
    grid-row-start: 2;
    grid-row-end: 2;
}
.workflo{
    position:relative;
}
.wfcontainer {
    overflow: hidden;
    position: relative;
}
.fixed-wrapper{
    overflow:hidden;
    position:absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
}
.pan-zoom-frame {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.expressionItem > * {
    align-self: center;
}

.propSelect {
    width: 200px;
}
.fullscreen {
    top: 0px;
    right: 0px;
    position: fixed;
    left: 0;
    bottom: 0;
    max-width:100%;
}
.panelbutton {
    background: var(--appbuilder-primary-color);
    display: flex;
    align-items: center;
    color: var(--appbuilder-hover-color);
    cursor:pointer;
}

.ZoomActions {
    height:40px;
    position:absolute;
    width: 270px;
    bottom:5px;
    left: 5px;
    font-family: var(--workflow-font-family);
}
.WorkflowAction{
    z-index:3;
}
.modules-wrapper{
    overflow:auto;
    padding-right:10px;
}

.workflow-module-item {
    height: 40px;
    display: flex;
    border: 0px solid black;
    border-radius: 10px;
    overflow: hidden;
    margin: 5px 0;
    box-shadow: 3px 3px 10px 0px rgba(0,0,0,0.16);
}
.workflow-name{
    position:absolute;
    bottom:10px;
    right:10px;
    background:white;
    border:0px solid white;
    border-radius:6px;
}

.playBox {
    border: 1px solid #D5D5D5;
    border-radius: 10px;
    position: relative;
}

    .playBox > .dropDownIcon {
        height: 100%;
        width: 24px;
        justify-content: center;
    }

.dropDownCB {
    margin-right: 8px;
}

.primaryFill {
    color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/app/workflow/workflow.control.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,sCAAsC;IACtC,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,YAAY;IACZ,aAAa;IACb;;;;+EAI2E;IAC3E,kBAAkB;IAClB,WAAW;IACX,4BAA4B;IAC5B,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,KAAK;IACL,QAAQ;IACR,MAAM;IACN,OAAO;AACX;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,QAAQ;IACR,UAAU;IACV,eAAe;IACf,OAAO;IACP,SAAS;IACT,cAAc;AAClB;AACA;IACI,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,wCAAwC;AAC5C;AACA;IACI,SAAS;AACb;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,6CAA6C;AACjD;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;IAEI;QACI,YAAY;QACZ,WAAW;QACX,uBAAuB;IAC3B;;AAEJ;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".contentDIV {\n    position: relative;\n    overflow: auto;\n    height: 500%;\n    width: 500%;\n    background: var(--workflow-background);\n    font-family: var(--workflow-font-family);\n}\n\n.leftColumn {\n    border-right: 1px solid black;\n    width: 275px;\n    position: relative;\n    font-family: var(--workflow-font-family);\n}\n.leftColumnHidden{\n    width:0px;\n}\n\n.moduleItem {\n    position: absolute;\n}\n\n.dropDIV {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0px;\n    left: 0px;\n    z-index: 1;\n}\n\n.treeDiv {\n    overflow: hidden;\n}\n\n.SettingsPanel {\n    width: auto;\n    background: var(--appbuilder-background);\n    height: auto;\n    padding: 10px;\n    /*border: var(--appbuilder-border-thickness) solid var(--appbuilder-border-color);\n    border-top-left-radius: var(--appbuilder-border-radius-top-left);\n    border-top-right-radius: var(--appbuilder--border-radius-top-right);\n    border-bottom-left-radius: var(--appbuilder--border-radius-bottom-left);\n    border-bottom-right-radius: var(--appbuilder--border-radius-bottom-right);*/\n    position: absolute;\n    z-index: 10;\n    grid-template-rows: 1fr auto;\n    display: grid;\n    max-width:1000px;\n}\n.SettingsPanelContent{\n    grid-row-start:1;\n    grid-row-end:1;\n    overflow:auto;\n    max-width:980px;\n}\n\n.fullscreen .SettingsPanelContent {\n    max-width: 100vw;\n}\n.SettingsPanelActions {\n    grid-row-start: 2;\n    grid-row-end: 2;\n}\n.workflo{\n    position:relative;\n}\n.wfcontainer {\n    overflow: hidden;\n    position: relative;\n}\n.fixed-wrapper{\n    overflow:hidden;\n    position:absolute;\n    top:0;\n    bottom:0;\n    left:0;\n    right:0;\n}\n.pan-zoom-frame {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n.expressionItem > * {\n    align-self: center;\n}\n\n.propSelect {\n    width: 200px;\n}\n.fullscreen {\n    top: 0px;\n    right: 0px;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    max-width:100%;\n}\n.panelbutton {\n    background: var(--appbuilder-primary-color);\n    display: flex;\n    align-items: center;\n    color: var(--appbuilder-hover-color);\n    cursor:pointer;\n}\n\n.ZoomActions {\n    height:40px;\n    position:absolute;\n    width: 270px;\n    bottom:5px;\n    left: 5px;\n    font-family: var(--workflow-font-family);\n}\n.WorkflowAction{\n    z-index:3;\n}\n.modules-wrapper{\n    overflow:auto;\n    padding-right:10px;\n}\n\n.workflow-module-item {\n    height: 40px;\n    display: flex;\n    border: 0px solid black;\n    border-radius: 10px;\n    overflow: hidden;\n    margin: 5px 0;\n    box-shadow: 3px 3px 10px 0px rgba(0,0,0,0.16);\n}\n.workflow-name{\n    position:absolute;\n    bottom:10px;\n    right:10px;\n    background:white;\n    border:0px solid white;\n    border-radius:6px;\n}\n\n.playBox {\n    border: 1px solid #D5D5D5;\n    border-radius: 10px;\n    position: relative;\n}\n\n    .playBox > .dropDownIcon {\n        height: 100%;\n        width: 24px;\n        justify-content: center;\n    }\n\n.dropDownCB {\n    margin-right: 8px;\n}\n\n.primaryFill {\n    color: var(--primary-color);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
